module.exports = __webpack_public_path__ + "img/use_selected.a63e733d.svg";